import React, { useEffect, useState, useRef } from "react";
import ReactPlayer from "react-player/lazy";
import { useLocation } from "react-router-dom";
import {
  getVodURLThunk,
  postLogThunk,
  postDeployThunk,
  getAdminVodURLThunk,
} from "../store/vodStore";
import { useDispatch, useSelector } from "react-redux";
import ErrorAxios from "./ErrorAxios";
import { findDOMNode } from "react-dom";
import { Button } from "@mui/material";
import { isFulfilled } from "@reduxjs/toolkit";
/***********  REACT-PLAYER  *************************
https://shinsangeun.github.io/posts/react/react-player
https://github.com/CookPete/react-player#props
https://cookpete.com/react-player/
https://github.com/cookpete/react-player/blob/master/src/demo/App.js
*****************************************************/
const Video = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname.split("/");
  const ref = useRef();
  const { url, kwamok, fileNM, error, admin, deploy, idx } = useSelector(
    (state) => state.vodStore
  );
  const [isLog, setIsLog] = useState(true); //플레이어 최초 재생시에만 로그 남기기 구분용 변수
  const [innerWidth, setInnerWidth] = useState(window.screen.width); //디바이스 사이즈 (width)
  const [innerHeight, setInnerHeight] = useState(window.screen.height); //디바이스 사이즈 (height)
  //console.log(admin, deploy)
  //console.log("url : ", url);
  //console.log("kwamok : ", kwamok);
  //console.log("fileNM : ", fileNM);
  //console.log(idx)
  //console.log("/"+path[1]+"/"+path[2]+"/"+path[3]+"/"+path[4]+"/"+path[5]+"/"+path[6]);

  //동영상 url 받아오기
  useEffect(() => {
    if (admin === "Y") {
      //관리자 화면
      dispatch(getAdminVodURLThunk({ param1: path[2], param2: path[3] }));
    } else if (admin === "N") {
      //사용자 화면
      dispatch(getVodURLThunk({ param1: location.pathname }));
    } else if (admin === "J") {
      //사용자 화면
      dispatch(getVodURLThunk({ param1: "/"+path[1]+"/"+path[2]+"/"+path[3]+"/"+path[4]+"/"+path[5]+"/"+path[6] }));
    } 
  }, [admin]);

  useEffect(() => {
    const resizeListener = () => {
      setInnerWidth(window.screen.width);
      setInnerHeight(window.screen.height);
    };
    window.addEventListener("resize", resizeListener);
  }, [innerWidth, innerHeight]);

  //플레이어 최초 재생 1회시에만 로그 남기기 (관리자 화면일 경우에는 로그 안 남김)
  const handleVideoStart = () => {
    isLog &&
      admin === "N" &&
      dispatch(
        postLogThunk({
          logGubun: path[1],
          data: path[6],
          screenWidth: innerWidth,
          screenHeight: innerHeight,
          pixelRatio: window.devicePixelRatio,
          userAgent: navigator.userAgent,
        })
      );
    //재능이랑 - HKEY 값도 로그 남겨줌 
    isLog &&
      admin === "J" &&
      dispatch(
        postLogThunk({
          logGubun: path[1],
          data: path[6],
          screenWidth: innerWidth,
          screenHeight: innerHeight,
          pixelRatio: window.devicePixelRatio,
          userAgent: navigator.userAgent,
          HSkey: path[7]
        })
      );
  };

  //플레이어 멈춤
  const handleVideoStop = () => {
    setIsLog(false);
  };

  //플레이어 영상 종료
  const handleVideoEnd = () => {
    setIsLog(false);
    window.parent.postMessage("ended", "*");
  };

  //플레이어 onstart 이벤트 발생시 FullScreen
  const handleVideoFull = () => {
    // console.log(ref.current)
    if (innerWidth * innerHeight < 914400) {
      findDOMNode(ref.current.player).requestFullscreen();
    }
  };

  //관리자 - 배포하기
  const handleVideoDeploy = async () => {
    if (window.confirm("배포하시겠습니까?")) {
      const action = await dispatch(
        postDeployThunk({
          param1: kwamok,
          param2: fileNM,
          param3: path[4],
          param4: idx,
        })
      );
      
      //1. return success -> alert("배포가 완료되었습니다.")
      if (isFulfilled(action)) {
        alert("배포가 완료되었습니다.");
      } else {
        alert("배포 중 오류가 발생했습니다.");
      }

      //2. window.opener.postMessage('ok', '*');
      window.opener.postMessage("ok", "*");
      //3. 현재 창 닫기
      window.open("", "_self").close();

    }
  };

  //영상 로드되고 재생할 준비가 되면 1초 뒤로 영상 이동
  const handleSeekClick = () => {
    ref.current.seekTo(1); // 1초로 이동
  };

  if (error) return <ErrorAxios />;

  return (
    <>
      <div
        className="wrapper"
        style={{
          minHeight: "100vh",
          maxHeight: "100%",
          backgroundColor: "black",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ReactPlayer
          className="react-player"
          style={{ maxWidth: "100vh", maxHeight: "100vh", height: "auto" }}
          width="100%" // 플레이어 크기 (가로)
          max-height="100vh"
          ref={ref}
          url={url} // 플레이어 url
          playing={false} // 자동 재생 유무
          muted={false} // 음소거 유무 => chrome정책으로 인해 자동 재생을 위해 mute 옵션을 true로 해줌 (무음인 경우 자동 재생 가능)
          controls={true} // 플레이어 컨트롤 노출 여부 (음량, 전체화면, 재생속도 등)
          pip={false} // pip 모드 설정 여부 (pip 모드 : 동영상을 소형 플레이어로 축소하여 핸드폰에서 다른 앱 사용하는 동안에도 계속 시청 가능하게 하는 기능)
          onPlay={() => handleVideoStart()}
          onPause={() => handleVideoStop()}
          onEnded={() => handleVideoEnd()}
          onStart={() => handleVideoFull()}
          //onReady={() => handleSeekClick()}
        />

        {admin === "Y" && deploy === "Y" && (
          <Button
            sx={{
              color: "#000000",
              bgcolor: "#FFFFFF",
              fontWeight: "bold",
              width: "150px",
              height: "50px",
              "&:hover": { background: "#FFFFFF", color: "#000000" },
            }}
            onClick={handleVideoDeploy}
          >
            배포하기
          </Button>
        )}
      </div>
    </>
  );
};

export default Video;
